import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { onBeforeUnmount, onMounted } from 'vue';
import { AnalyticsAPI } from '../../legacy/api/analytics';

type Modifiers = Partial<Pick<KeyboardEvent, 'altKey' | 'metaKey' | 'shiftKey' | 'ctrlKey'>>;


export default /*@__PURE__*/_defineComponent({
  __name: 'hot-key',
  props: {
    apple: {},
    other: {},
    preventDefault: { type: Boolean, default: true },
    onAction: { type: Function, default: undefined }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const platform = ((navigator as any).userAgentData?.platform || navigator.platform).toLowerCase();
const isMac = platform.includes('mac');

const hotkeyConfig = isMac ? __props.apple : __props.other;

const hotkeyString = stringifyHotkey(hotkeyConfig.mods, hotkeyConfig.key);

function isModifiersMatch(e: KeyboardEvent, mods: Modifiers) {
  return (
    e.metaKey === (mods.metaKey ?? false)
    && e.shiftKey === (mods.shiftKey ?? false)
    && e.altKey === (mods.altKey ?? false)
    && e.ctrlKey === (mods.ctrlKey ?? false)
  );
}

function stringifyHotkey(mods: Modifiers, key: string) {
  const parts: string[] = [];

  if (mods.metaKey) {
    parts.push(isMac ? 'Cmd' : 'Win');
  }
  if (mods.ctrlKey) {
    parts.push('Ctrl');
  }
  if (mods.altKey) {
    parts.push('Alt');
  }
  if (mods.shiftKey) {
    parts.push('Shift');
  }
  parts.push(key);

  const thinsp = ' ';
  return parts.join(`${thinsp}+${thinsp}`);
}

function handleKeydown(e: KeyboardEvent) {
  if (e.key?.toLowerCase() === hotkeyConfig.key.toLowerCase() && isModifiersMatch(e, hotkeyConfig.mods)) {
    if (__props.preventDefault) {
      e.preventDefault();
    }
    emit('action');
    AnalyticsAPI.send('hotkey', { hotkey: hotkeyString });
  }
}

onMounted(() => {
  if (__props.onAction) {
    window.addEventListener('keydown', handleKeydown);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown);
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { hotkey: _unref(hotkeyString) })
}
}

})